import { gql, useQuery } from "@apollo/client";

const GET_SHIFT_STREAM_INFO = gql`
  query getShiftStreamInfo($shiftId: ID!, $memberIds: [ID]) {
    account {
      id
      shift(id: $shiftId) {
        stream {
          sources(memberIds: $memberIds) {
            id
            candidates
            gender
            numberRequested
            numberFilled
            url
            screenUrl
          }
        }
      }
    }
  }
`;

export const useStreamInfo = (shiftId, memberIds) => {
  const { data, loading } = useQuery(GET_SHIFT_STREAM_INFO, {
    variables: { shiftId, memberIds },
    skip: !shiftId,
    fetchPolicy: "network-only"
  });

  return {
    sources: [...(data?.account?.shift?.stream?.sources ?? [])],
    sourceMap: new Map(
      data?.account?.shift?.stream?.sources?.map(source => [
        source.id,
        source
      ]) ?? []
    ),
    loading
  };
};
